<template>
    <div id="overlayLoading" v-show="loadingPage">
		<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
	</div>
</template>

<script>
export default {
	props:["loadingPage"]
}
</script>

<style>

</style>